// src/pages/personal/settings/PlatformSettingsSection/PlatformSettingsSection.tsx
import React from 'react';

const PlatformSettingsSection: React.FC = () => {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Настройки платформы</h2>
      <p>Здесь будут отображаться настройки платформы. Секция находится в разработке.</p>
      
      <div className="mt-4">
        <h3 className="text-lg font-medium mb-2">Доступные настройки</h3>
        <ul className="list-disc pl-5">
          <li>Общие настройки</li>
          <li>Настройки уведомлений</li>
          <li>Интеграции</li>
          <li>API доступ</li>
        </ul>
      </div>
    </div>
  );
};

export default PlatformSettingsSection;